module.exports = __webpack_public_path__ + "img/bg_xslr_sjlr_l@2x.893216fd.png";